export default __webpack_public_path__ + "tmp_src/components/ProductCard/ProductCard~nova.css.liquid";